<template>
    <div class="p20">
        <h3 class="text-center">计费规则</h3>
        <div class="text-left pt10">
            <p class="pb10">
                按小时租借:每{{cabinetInfo&&cabinetInfo.chargeType == 'HOUR'?'小时':cabinetInfo&&cabinetInfo.chargeType == 'DAY'?'天':'分钟'}}{{cabinetInfo&&cabinetInfo.chargeMoney}}元计费(具体收费按医院情况而定)，5分钟内免费。
            </p>
            <p class="pb10">
                分时段租借:正常租借时间段内，按每小时1—2元计费，非时段租借按5元一小时计费。(具体收费根据医院而定）
            </p>
            <p class="pb10">
                归还轮椅时，请确保账号余额充足，如因余额不足无法及时代扣费用，可能会影响您的信用分数。
            </p>
        </div>
    </div>
</template>

<script>
    import cabinetServ from '../service/cabinetServ'
    import mintUi from '../lib/mint-ui'
    export default {
        data () {
            return {
                headPhoto: '/static/images/touxiang@2x.png',
                userName: '',
                isLoading: false,
                isNormal: null,
                cabinetInfo: null,
                number: null,
                qrCode: null,
                hasMore: false,
                isBackBed: null,
                list: null,
                wxId: null,
                giveBackList: null,
                alipayWap: null,
                isDisabled: false,
                bannerList: [],
                timerList:[],
                isFree: null,
                isMz: null
            }
        },
        created () {
            let qrCode = this.$route.query.qrCode
            console.log('qrCode:'+this.$route.query.qrCode)
            this.qrCode = qrCode
            this.getCabinetSta(qrCode)
        },
        methods: {
            // 获取设备状态
            getCabinetSta (qrCode){
                this.isLoading = true
                cabinetServ.getCabinetStatus(qrCode).then(res =>{
                    this.isLoading = false
                    if(res.code === '200'){
                        if(!res.data){

                        } else {
                            this.cabinetInfo = res.data.cabinet
                        }
                    } else {
                        mintUi.Toast({
                            message: res.message,
                            position: 'bottom'
                        })
                    }
                })
            },
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
    @import '../less/_var.less';
    @import '../less/index.less';
</style>


// WEBPACK FOOTER //
// src/pages/expenses.vue